import { render, staticRenderFns } from "./ButtonModal.vue?vue&type=template&id=e1442934&scoped=true"
import script from "./ButtonModal.vue?vue&type=script&lang=js"
export * from "./ButtonModal.vue?vue&type=script&lang=js"
import style0 from "./ButtonModal.vue?vue&type=style&index=0&id=e1442934&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1442934",
  null
  
)

export default component.exports